import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import styles from './styles.module.scss'

export interface MarketingQuoteProps {
  quote: React.ReactNode
  name: React.ReactNode
  designation: React.ReactNode
}

const MarketingQuote = ({ quote, name, designation }: MarketingQuoteProps) => {
  const [getClassName, makeTestId] = useNameFormatter('MarketingQuote')

  return (
    <div className={styles[getClassName('')]}>
      <div
        className={styles[getClassName('quote')]}
        data-testid={makeTestId('quote')}
      >
        {quote}
      </div>
      <div
        className={styles[getClassName('citation')]}
        data-testid={makeTestId('citation')}
      >
        {name}
        {designation}
      </div>
    </div>
  )
}

export default MarketingQuote
